import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import { Card } from '../../components/ui/card';
import { DollarSign } from 'lucide-react';
import { toast } from 'sonner';

const DonationViewer = () => {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDonations();
  }, []);

  const fetchDonations = async () => {
    try {
      const response = await api.get('/admin/donations');
      setDonations(response.data);
    } catch (error) {
      toast.error('Failed to load donations');
    } finally {
      setLoading(false);
    }
  };

  const totalAmount = donations
    .filter(d => d.payment_status === 'paid')
    .reduce((sum, d) => sum + d.amount, 0);

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Donations</h2>
      
      <Card className="p-6 mb-6">
        <div className="flex items-center space-x-4">
          <DollarSign className="w-12 h-12 text-green-600" />
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">Total Donations Received</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">
              ${totalAmount.toFixed(2)}
            </p>
          </div>
        </div>
      </Card>

      <div className="space-y-4">
        {loading ? (
          <p className="text-center py-8">Loading...</p>
        ) : donations.length > 0 ? (
          donations.map((donation) => (
            <Card key={donation.id} className="p-6">
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-bold text-lg">${donation.amount.toFixed(2)}</p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {donation.donor_name || 'Anonymous'} • {donation.donor_email || 'No email'}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    {new Date(donation.created_at).toLocaleDateString()}
                  </p>
                </div>
                <span className={`px-3 py-1 rounded-full text-sm ${
                  donation.payment_status === 'paid' 
                    ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
                    : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300'
                }`}>
                  {donation.payment_status}
                </span>
              </div>
            </Card>
          ))
        ) : (
          <Card className="p-8 text-center">
            <p className="text-gray-600 dark:text-gray-400">No donations yet.</p>
          </Card>
        )}
      </div>
    </div>
  );
};

export default DonationViewer;
